import type { EntityConfig } from '../types'

export const digitalEntity: EntityConfig = {
  id: 'digital',
  displayName: 'Digital',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' }
    ],
    mappings: {
      all: ['active', 'inactive'],
      active: ['active'],
      inactive: ['inactive']
    }
  },
  queryFields: {},
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
  ]
}
